module.exports = __webpack_public_path__ + "img/incomeBg_54b52.png";